class LoadContentOnClick{
  constructor(loadMoreButton, loadMoreElements,loadMoreWrapper) {
      try {
        this.loadMoreButton =  loadMoreButton;
        this.loadMoreContainer = loadMoreElements;
        this.dataUrl = loadMoreWrapper.getAttribute("data-url");
        this.loadmessage = document.createElement("span");
        this.loadmessage.innerHTML = 'Loading...'

        this.loadMoreButton.forEach((button,i) => {
          button.addEventListener("click", () => this.onClickLoadMore(button,this.loadMoreContainer[i]));
        });
      }catch (error) {
          console.log('nope',error);
      }
  }
  onClickLoadMore = async (button,element) => {
    let idCruiseRoute = button.getAttribute('data-el-ref');
    element.appendChild(this.loadmessage);
    fetch(this.dataUrl+'?cruiseref='+idCruiseRoute, {method:'GET'})
      .then(
        result => result.json()
      )
      .then(data => {
        this.loadmessage.remove();
        element.innerHTML = data.route;
      })
      .catch(
        error => {console.log(error);}
      )
  }
}

export default LoadContentOnClick;